import { IObservable, Subject } from '~/rage/utils';
import { IHudWeather, WeatherType } from '~/shared';
import { IWeatherService } from './weatherServiceTypes';

export class WeatherServiceStub implements IWeatherService {
	private weather = new Subject<IHudWeather>({
		weather: WeatherType.EXTRASUNNY,
		degrees: 20,
	});

	public getWeather(): IObservable<IHudWeather> {
		return this.weather;
	}
}
